import { render, staticRenderFns } from "./MemberTypeCreateAndUpdateFormItems.vue?vue&type=template&id=404471f2&"
import script from "./MemberTypeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./MemberTypeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./MemberTypeCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports